import styled from "styled-components";

export const ArtprojectContainer = styled.section`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
  background-color: lightcoral;
  padding: 50px;

  @media (min-width: 1000px) {
    flex-direction: row;
  }
`;

export const ArtprojectImageWrapper = styled.div`
  display: flex; 
  flex-wrap: wrap;
  justify-content: space-between;
  height: fit-content;
  width: 423px;
  margin-bottom: 100px;

  @media (min-width: 800px) and (max-width: 1000px) {
    width: 350px;
    height: 350px;
  }

  @media (max-width: 800px) {
    width: 250px;
    height: 250px;
  }
`;

export const ArtProjectImage = styled.img`
  width: 423px;
  height: 423px;
  overflow: hidden;
  object-fit: cover;

  @media (min-width: 800px) and (max-width: 1000px) {
    width: 350px;
    height: 350px;
  }

  @media (max-width: 800px) {
    width: 250px;
    height: 250px;
  }
`;

export const NextImageButton = styled.button`
  background: transparent;
  border: none;
  width: 50px;
`;

export const NextImageButtonArrow = styled.img`
  width: 100%;
`;

export const ArtprojectTextWrapper = styled.div`
  letter-spacing: -0.5;
  font-family: 'Spectral', 'times', serif;
  font-size: 1.3rem;
  line-height: 1.3;

  @media (min-width: 1024px) {
    margin: 0 50px;
  }
`;

export const ArtprojectInfo = styled.h4`
  margin: 0;
  text-transform: uppercase;
  font-weight: light;
`;

export const ArtprojectText = styled.p`
  letter-spacing: -0.5;
  font-family: 'Spectral', 'times', serif;
  font-size: 1.3rem;
  line-height: 1.3;
  width: fit-content;
`;

export const ArtprojectLink = styled.a`
  color: inherit;
`;